document.addEventListener('DOMContentLoaded', function() {
  // Find all radio buttons on the page
  var allRadioButtons = document.querySelectorAll('input[type="radio"]');
  
  // Make sure they are visible and functioning as radio buttons
  allRadioButtons.forEach(function(radio) {
    radio.style.opacity = '1';
    radio.style.position = 'relative';
    radio.style.pointerEvents = 'auto';
  });

  // Handle the account type selection (if it exists on this page)
  var accountTypeContainer = document.getElementById('RegisterForm-AccountType');
  var tagsInput = document.getElementById('customer_tags');
  
  if (accountTypeContainer && tagsInput) {
    accountTypeContainer.addEventListener('change', function() {
      // Find the checked radio button within the group
      const selected = document.querySelector('input[name="customer[note][Account Type]"]:checked');
      if (selected) {
        const accountType = selected.value;
        if (accountType === 'installer') {
          tagsInput.value = 'b2b-tier-3-pending-installer';
        } else if (accountType === 'exporter') {
          tagsInput.value = 'b2b-tier-2-export';
        } else {
          tagsInput.value = 'b2b-tier-4-end-customer';
        }
      }
    });
  }
});